import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { DrawingBomContext } from "../../DrawingBomContext/index.jsx";
import { modalStyle } from "../../../../../../../../../components/modalStyle.js";
import { Button, Typography, Grid, Snackbar } from "@mui/material";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { drawingMaterialsCols } from "../../../Components/cols/drawingsMaterialsCols.js";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SharePointIcon from "../../../../../../../../../components/CustomIcons/SharePointIcon.jsx";
import StorageIcon from "@mui/icons-material/Storage";
import IDComponent from "./IDComponent.jsx";
import CopyUrlButton from "../../../../../../../../../components/btns/CopyLinkBtn.jsx";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import CopyAndVisitIconsBtns from "../../../../../../../../../components/btns/CopyAndVisitIconsBtns.jsx";
import { lightTable } from "../../../../../../../../../styles/muiProps.js";
import { useBOMDashboardContext } from "../../../BOMDashboard.context.jsx";
import { handleAddToCO } from "./handleAddToCO";
import COForm from "./COForm.jsx";
import ColoredSnackbar from "../../../../../../../../../components/ColoredSnakebar.jsx";

export default function ComparingModal() {
  const { project } = useBOMDashboardContext();
  const {
    openCompare,
    handleCloseCompareModal,
    comparedDrawing,
    selectedDrawings,
    handleAddingNewDrawing,
  } = React.useContext(DrawingBomContext);

  const [rowSelection, setRowSelection] = useState({});
  const [showCOForm, setShowCOForm] = useState(false);
  const [materialsWithPreviousCO, setMaterialsWithPreviousCO] = useState([]);

  const [submitSuccess, setSubmitSuccess] = useState(null);
  const handleCloseSuccessSnackbar = () => {
    setSubmitSuccess(false);
  };

  // console.log("comparedDrawing", comparedDrawing);
  const states = [
    {
      label: "Deleted",
      state: "deleted",
      color: "red",
      icon: <ClearIcon sx={{ color: "red" }} />,
    },
    {
      label: "New",
      state: "added",
      color: "green",
      icon: <AddCircleIcon sx={{ color: "green" }} />,
    },
    {
      label: "Edited",
      state: "changed",
      // color: "#DC9B50",
      color: "red",
      icon: <EditIcon color="primary" />,
    },
    {
      label: "Unchanged",
      state: "unchanged",
      color: "white",
      icon: <CheckCircleIcon sx={{ color: "#bbb" }} />,
    },
  ];

  const getDrawingSubLink = (drawingId) => {
    return (
      `/projects/${project?.id}/equipments/main_tank#main-nav=MCS&mcs-tab=Drawing%20BOM&drawing-id=` +
      drawingId
    );
  };

  const columns =
    drawingMaterialsCols(selectedDrawings?.[0]?.materials)
      ?.map((col) => {
        return {
          ...col,
          Cell: ({ row, column }) => {
            const m = row.original;
            const rowState = m.comparingState;
            const comparingKey = m.comparingKey;
            // console.log(comparingKey);
            const cellKey = column.id;
            const cellColor =
              comparingKey === cellKey
                ? states.find((s) => s.state === rowState).color
                : "black";

            return (
              <Box
                sx={{
                  padding: "8px",
                  color:
                    rowState === "added"
                      ? "green"
                      : rowState === "deleted"
                        ? "red"
                        : cellColor,
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: col.accessorKey === comparingKey && "yellow",
                }}
              >
                <Box sx={{ display: "inline-block", pr: 1 }}>
                  {["markNumber", "tagNumber"].includes(cellKey)
                    ? states.find((s) => s.state === rowState)?.icon
                    : ""}{" "}
                </Box>
                <Box sx={{ display: "inline-block" }}>{m[col.accessorKey]}</Box>
              </Box>
            );
          },
        };
      })
      .filter((c) => !["wt", "progress", "co"].includes(c.accessorKey)) || [];

  const generalTable = {
    columns,
    ...lightTable,
    enableStickyHeader: true,
    muiTableContainerProps: { sx: { maxHeight: "500px" } },
  };

  const data1 = React.useMemo(() => {
    return [...(comparedDrawing?.v1 || [])].sort((a, b) =>
      String(a.tagNumber || "").localeCompare(
        String(b.tagNumber || ""),
        undefined,
        { numeric: true },
      ),
    );
  }, [comparedDrawing?.v1]);

  const data2 = React.useMemo(() => {
    return [...(comparedDrawing?.v2 || [])].sort((a, b) =>
      String(a.tagNumber || "").localeCompare(
        String(b.tagNumber || ""),
        undefined,
        { numeric: true },
      ),
    );
  }, [comparedDrawing?.v2]);

  const table1 = useMaterialReactTable({
    data: data1 || [],

    ...generalTable,
  });

  const handleRowSelectionChange = (updater) => {
    setRowSelection((prev) => {
      const newSelection =
        typeof updater === "function" ? updater(prev) : updater;

      setMaterialsWithPreviousCO([]);
      Object.keys(newSelection).forEach((id) => {
        const m = data2.find((d2m) => d2m.id === id);
        if (m.changeOrders?.[0]?.id) {
          setMaterialsWithPreviousCO([m]);
        }
      });

      return newSelection;
    });
  };

  const table2 = useMaterialReactTable({
    data: data2 || [],
    ...generalTable,

    enableRowSelection: true,
    // enableSelectAll: false,
    getRowId: (row) => row.id,
    state: { rowSelection },
    onRowSelectionChange: handleRowSelectionChange,
  });

  const onAddingValidatedDrawingToMCS = () => {
    // get drawing Id = comparedDrawing?.ids?.[1])
    handleAddingNewDrawing({ drawing: selectedDrawings?.[1] });
    handleCloseCompareModal();
  };

  const selectedCOMaterials = table2
    .getSelectedRowModel()
    .rows.map((r) => r.original);

  const onAddToCO = () => {
    setShowCOForm(true);

    // handleAddToCO({ selectedCOMaterials, handleCloseCompareModal });
  };

  let itemNumbers = "";

  materialsWithPreviousCO.forEach((m) => {
    itemNumbers += ` ${m.item} `;
  });
  return (
    <div>
      {" "}
      <Modal open={openCompare} onClose={handleCloseCompareModal}>
        <Box
          sx={{
            ...modalStyle,
            width: "95%",
            maxHeight: "95%",
            position: "relative",
          }}
        >
          <Box sx={{ display: "inline-block" }}>
            <Typography variant="h5" sx={{ pb: 2 }}>
              Compare Drawing changes :
            </Typography>
            <Grid container sx={{ width: 500 }}>
              <Grid item xs={3}>
                <Typography variant="h7" sx={{}}>
                  Drawing Name :{" "}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                {comparedDrawing?.name}
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={3}>
                <Typography variant="h7" sx={{}}>
                  Drawing Sheet :{" "}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                {comparedDrawing?.sheetNumber}
              </Grid>
            </Grid>
            {/* <Grid container sx={{ my: 1 }}>
              <Grid item xs={6}>
                <Typography variant="h7" sx={{ lineHeight: 2 }}>
                  Drawing Selected Revisions :{" "}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {comparedDrawing?.revs?.map((rev) => {
                  return <Chip key={rev} label={rev} sx={{ mx: 0.3 }} />;
                })}
              </Grid>
            </Grid> */}
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              mt: -3,
              mb: 1,
            }}
          >
            {states.map((s) => {
              return (
                <Box
                  sx={{ display: "flex", alignItems: "center", mx: 1.5 }}
                  key={s.state}
                >
                  <span style={{ marginRight: "7px" }}>{s.icon}</span>
                  {"     "} {s.label}
                </Box>
              );
            })}
          </Box>

          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={6}>
              <Typography
                variant="h7"
                sx={{ textAlign: "center", lineHeight: 2.5 }}
              >
                Source:{" "}
                {selectedDrawings?.[0]?.selectedSource === "sharepoint" ? (
                  <SharePointIcon
                    size={25}
                    sx={{ transform: "translateY(6px)" }}
                  />
                ) : (
                  <StorageIcon
                    sx={{ color: "blue", transform: "translateY(6px)" }}
                  />
                )}
                {"   ("}
                Rev- {comparedDrawing?.revs?.[0]}
                {")"}
                <CopyUrlButton
                  label="Share Drawing Link"
                  subLink={getDrawingSubLink(comparedDrawing?.ids?.[0])}
                  sx={{ ml: 1 }}
                />
                <IDComponent id={comparedDrawing?.ids?.[0]} />
              </Typography>

              <MaterialReactTable table={table1} />
            </Grid>
            <Grid item xs={6}>
              <Typography
                variant="h7"
                sx={{ textAlign: "center", lineHeight: 2.5 }}
              >
                Source:{" "}
                {selectedDrawings?.[1]?.selectedSource === "sharepoint" ? (
                  <SharePointIcon
                    size={23}
                    sx={{
                      transform: "translateY(6px)",
                      display: "inline-block",
                    }}
                  />
                ) : selectedDrawings?.[1]?.selectedSource === "freecad" ? (
                  <img
                    alt="freecad"
                    src="/public/icons/freecad-icon.png"
                    width={5}
                    height={5}
                  />
                ) : (
                  // <StorageIcon
                  //   sx={{ color: "blue", transform: "translateY(6px)" }}
                  // />
                  <img
                    alt="freecad"
                    src="/icons/freecad-icon.png"
                    width={20}
                    height={20}
                    style={{
                      transform: "translateY(4px)",
                    }}
                  />
                )}
                {"   ("}
                Rev- {comparedDrawing?.revs?.[1]}
                {")"}
                <CopyAndVisitIconsBtns
                  label="Share Drawing Link"
                  subLink={getDrawingSubLink(comparedDrawing?.ids?.[1])}
                  sx={{ ml: 1, transform: "translateY(7px)" }}
                />
                <IDComponent id={comparedDrawing?.ids?.[1]} />
              </Typography>
              <MaterialReactTable table={table2} />
            </Grid>
          </Grid>

          {!showCOForm && materialsWithPreviousCO.length && (
            <Typography sx={{ color: "red", textAlign: "center", mt: 1 }}>
              {`Materials with Item Numbers: [${itemNumbers}] are included in Previous Change order.`}
            </Typography>
          )}

          <Box sx={{ textAlign: "right", pt: 1, mt: 1 }}>
            <CopyUrlButton label="Copy Validation Link" />
            <Button
              variant="contained"
              sx={{ mx: 1 }}
              endIcon={<ExitToAppIcon sx={{ transform: "translateY(-2px)" }} />}
              onClick={onAddToCO}
              disabled={
                !selectedCOMaterials?.length || materialsWithPreviousCO.length
              }
            >
              Add to CO
            </Button>
            <Button color="error" onClick={handleCloseCompareModal}>
              Close
            </Button>
          </Box>

          {showCOForm && (
            <Box>
              <COForm
                setShowCOForm={setShowCOForm}
                setSubmitSuccess={setSubmitSuccess}
                selectedCOMaterials={selectedCOMaterials}
              />
            </Box>
          )}
          <Box
            sx={{
              position: "absolute",
              bottom: -5,
              left: 2,
              width: "50%",
            }}
          >
            <ColoredSnackbar
              open={submitSuccess}
              onClose={handleCloseSuccessSnackbar}
              message="Change Order created successfully!"
              severity="success"
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
